import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      id: 'moving',
      title: '引越しサービス',
      description: '単身から家族まで、あらゆる引越しに対応。丁寧・迅速・安心の引越しをお約束します。',
      image: 'https://public.readdy.ai/ai/img_res/668a0707af9869eb03ac0c05f6a67c1d.jpg',
      link: '/moving',
      icon: 'ri-truck-line'
    },
    {
      id: 'furniture',
      title: '家具・家電運搬',
      description: '大型家具や家電の運搬・設置を安全に。模様替えや買い替え時もお任せください。',
      image: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20flat%20design%20illustration%20of%20a%20cozy%20living%20room%20interior%20with%20large%20furniture%20pieces%20like%20a%20comfortable%20sofa%20wooden%20bookshelf%20and%20dining%20table%20arranged%20in%20a%20welcoming%20space%20with%20soft%20beige%20and%20yellow%20tones%20simple%20clean%20lines%20and%20a%20homey%20atmosphere%20no%20vehicles%20no%20people%20focus%20on%20the%20furniture%20arrangement%20and%20interior%20design&width=1920&height=600&seq=furniture-hero-v2&orientation=landscape',
      link: '/furniture',
      icon: 'ri-home-4-line'
    },
    {
      id: 'disposal',
      title: '不用品整理',
      description: '不要な家具・家電の回収から処分まで。お部屋をスッキリ快適な空間に。',
      image: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20flat%20design%20illustration%20of%20organized%20unwanted%20items%20and%20furniture%20ready%20for%20disposal%20including%20old%20chairs%20boxes%20small%20appliances%20and%20household%20goods%20neatly%20arranged%20in%20a%20clean%20space%20with%20soft%20beige%20and%20yellow%20tones%20simple%20clean%20lines%20and%20an%20organized%20atmosphere%20no%20vehicles%20no%20people%20focus%20on%20the%20items%20being%20sorted%20and%20prepared%20for%20removal&width=1920&height=600&seq=disposal-hero-v2&orientation=landscape',
      link: '/disposal',
      icon: 'ri-delete-bin-line'
    },
    {
      id: 'cargo',
      title: '貨物配送',
      description: '企業様向けの定期配送から個人のお荷物まで、確実にお届けします。',
      image: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20flat%20design%20illustration%20of%20a%20warehouse%20interior%20with%20organized%20cargo%20packages%20cardboard%20boxes%20of%20various%20sizes%20neatly%20stacked%20on%20shelves%20and%20pallets%20with%20shipping%20labels%20in%20a%20clean%20logistics%20environment%20with%20soft%20beige%20and%20yellow%20tones%20simple%20clean%20lines%20and%20an%20efficient%20organized%20atmosphere%20no%20vehicles%20no%20people%20focus%20on%20the%20packages%20and%20warehouse%20organization&width=1920&height=600&seq=cargo-hero-v2&orientation=landscape',
      link: '/cargo',
      icon: 'ri-box-3-line'
    }
  ];

  return (
    <section className="py-12 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            サービス内容
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600">
            お客様のニーズに合わせた幅広いサービスを提供
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {services.map((service) => (
            <Link
              key={service.id}
              to={service.link}
              className="group relative rounded-2xl md:rounded-3xl overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-56 sm:h-64 md:h-80 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent"></div>
              </div>
              
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 md:p-8">
                <div className="flex items-center gap-2 md:gap-3 mb-2 md:mb-3">
                  <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-[#ebe960] rounded-full flex items-center justify-center">
                    <i className={`${service.icon} text-lg sm:text-xl md:text-2xl text-gray-900`}></i>
                  </div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white">
                    {service.title}
                  </h3>
                </div>
                <p className="text-white/90 text-xs sm:text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
